<template>
    <div>
        <div class="weui-panel weui-panel_access" v-if="data != null">
            <div class="weui-panel__bd">
                <div class="weui-media-box weui-media-box_appmsg">
                    <div class="weui-media-box__hd">
                        <img class="weui-media-box__thumb" :src="data.cover" alt="">
                    </div>
                    <div class="weui-media-box__bd">
                        <h4 class="weui-media-box__title">{{data.title}}</h4>
                        <p class="weui-media-box__desc">{{data.excerpt}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="weui-panel weui-panel_access" v-if="data != null">
            <div class="weui-panel__hd">说明</div>
            <div class="weui-panel__bd">
                <markdown :markdown="data.content">
                    <hr/>
                    <h4>适用级别</h4>
                    <ul>
                        <li>{{data.role_display_name}}</li>
                    </ul>
                    <br/>
                </markdown>
            </div>
        </div>

        <p class="weui-btn-area" v-if="data != null">
            <template v-if="data.status == 'onsale'">
                <router-link :to="theRoute" class="weui-btn weui-btn_primary">进入</router-link>
            </template>
            <button class="weui-btn weui-btn_disabled weui-btn_primary" v-else>即将推出</button>
        </p>
    </div>
</template>

<script>
import Markdown from "@/components/Markdown";

export default {
    name: "ServiceView",
    props: ["id"],
    data: function() {
        return {
            data: null
        };
    },
    created () {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData()
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'fetchData'
    },
    computed: {
        theRoute: function() {
            return {
                path: `/service/${this.$route.params.id}${this.data.route}` 
            }
        }
    },
    methods: {
        fetchData: function() {
            this.$store.commit('loading');
            this.$axios.get(`service/${this.$route.params.id}`).then(response => {
                this.data = response.data;

                this.$store.commit('loading', false);
            });
        }
    },
    components: {
        Markdown
    }
};
</script>
